<template>
  <div>
    <v-container>
      <v-layout wrap class="mb-4">
        <v-flex xs9>
          <h3 class="headline mt-0">{{ $t('Shipping Method') }}</h3>
        </v-flex>
        <v-flex xs3 class="text-xs-right">
          <v-btn
            fab
            outline
            small
            color="primary"
            v-if="!isEditPaymentDetail"
            @click="isEditPaymentDetail = true"
          >
            <i class="fa fa-pencil-alt middle"></i>
          </v-btn>
        </v-flex>
      </v-layout>
      <shipping-detail
        :isEdit="isEditPaymentDetail"
        :init="contents"
        @onSave="isEditPaymentDetail = false"
      ></shipping-detail>
    </v-container>
    <v-divider />

    <template>
      <v-container>
        <div style="border-radius: 15px; border: 1px solid #eee; overflow: hidden">
          <v-layout wrap>
            <v-flex
              xs12
              sm6
              style="background: url(https://www.shippop.com/assets/images/frontpage/slider/slide3.png?v=1497285980); background-position: center;
    background-repeat: no-repeat;
    background-size: cover;"
            >
            </v-flex>
            <v-flex xs12 sm6 class="text-xs-center px-2 py-4">
              <v-layout justify-center align-center row style="height: 100%">
                <v-flex>
                  <div class="headline">
                    ขายสินค้าต่อเนื่องแบบไม่มีสะดุด
                  </div>
                  <div class="mb-2">
                    SHIPPOP X ZWIZ.AI
                  </div>
                  <v-btn depressed color="primary" large @click="gotoshippop">
                    ดูรายละเอียด
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
      </v-container>
      <v-divider />
    </template>

    <v-container id="shippop">
      <shippop-manage></shippop-manage>
    </v-container>

    <div style="height: 60px"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'

import ShippingDetail from '@/components/view/setting/ecommerce/ShippingDetail'
import ShippopManage from './ShippopManage'
import goTo from 'vuetify/lib/components/Vuetify/goTo'
export default {
  data() {
    return {
      isEditPaymentDetail: false,
      isTransfer: false,
      isCreditCard: false,
      contents: []
    }
  },
  components: {
    ShippingDetail,
    ShippopManage
  },
  mounted() {
    this.getSetting()
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  methods: {
    gotoshippop() {
      this.$el.querySelector('[id="shippop"]').scrollIntoView()
    },
    getSetting: function() {
      let vm = this
      var data = {
        pageid: vm.selectedBot.pageid
      }

      api.getSetting(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
        vm.contents = {}
        if (response.data) {
          response.data.map(function(setting, index) {
            vm.contents[setting.contenttype] = setting
            if (setting.contenttype === 'allowtransfer') {
              vm.isTransfer = setting.contentvalue
            }
            if (setting.contenttype === 'allowcreditcard') {
              vm.isCreditCard = setting.contentvalue
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ShippingMethod.vue